import { Icon } from '@w7/ui'
import { StrixMark } from './StrixMark'

/**
 * Option 03 — Editorial magazine stage (concept-matched assets + 4 pillars).
 */

const PILLARS = [
  {
    id: '01',
    title: 'Downline',
    line: 'Manage your network. Drive performance.',
    icon: 'users' as const,
    image: '/auth/editorial/downline.png',
  },
  {
    id: '02',
    title: 'Exposure',
    line: 'Monitor risk. Maximize control.',
    icon: 'exposure' as const,
    image: '/auth/editorial/exposure.png',
  },
  {
    id: '03',
    title: 'Commission',
    line: 'Track commissions. Unlock earnings.',
    icon: 'commission' as const,
    image: '/auth/editorial/commission.png',
  },
  {
    id: '04',
    title: 'Live control',
    line: 'Match-day decisions. Calm under pressure.',
    icon: 'live' as const,
    image: '/auth/editorial/live.png',
  },
] as const

export function LoginStage() {
  return (
    <aside className="w7-auth-stage" aria-hidden="true">
      <div className="w7-auth-editorial">
        <div className="w7-auth-hero">
          <img
            className="w7-auth-hero-img"
            src="/auth/editorial/hero.png"
            alt=""
            decoding="async"
            fetchPriority="high"
          />
          <div className="w7-auth-hero-scrim" />

          <div className="w7-auth-hero-rail" />
          <div className="w7-auth-hero-dots">
            <span />
            <span />
            <span className="is-active" />
          </div>

          <div className="w7-auth-hero-top">
            <StrixMark className="w7-auth-hero-logo" size={28} />
          </div>

          <div className="w7-auth-hero-copy">
            <p className="w7-auth-hero-kicker">Live</p>
            <h2 className="w7-auth-hero-title">control</h2>
            <p className="w7-auth-hero-sub">Real-time insights. Superior outcomes.</p>
          </div>

          <div className="w7-auth-hero-foot">
            <span className="w7-auth-hero-plus" />
            <p>
              Built <em>for</em> professionals. Engineered to win.
            </p>
            <p className="w7-auth-hero-ver">Strix</p>
          </div>
        </div>

        <div className="w7-auth-pillars">
          {PILLARS.map((p) => (
            <article key={p.id} className="w7-auth-pillar">
              <img className="w7-auth-pillar-img" src={p.image} alt="" decoding="async" />
              <div className="w7-auth-pillar-scrim" />
              <div className="w7-auth-pillar-meta">
                <span className="w7-auth-pillar-num">{p.id}</span>
                <Icon name={p.icon} size={15} />
              </div>
              <div className="w7-auth-pillar-copy">
                <h3>{p.title}</h3>
                <p>{p.line}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </aside>
  )
}
